import React, { useState, useEffect } from 'react';
import ECharts from 'echarts-for-react';
import { getChartUnit } from 'Util';

const RelativeRate = ({ data, title }) => {
  
  const [options, setOptions] = useState();

  useEffect(() => {
    if (data !== null) {
      const lineColor = ['#1d2a53', '#F15050'];
      const option = {
        animation: false,
        legend: {
          orient: 'horizontal',
          right: 5,
          top: -4,
          textStyle: { fontSize: 10 },
          itemStyle: { opacity: 0 },
          data: [{
            name: title[0],
            lineStyle: { color: lineColor[0] }
          }, {
            name: title[1],
            lineStyle: { color: lineColor[1] }
          }]
        },
        grid: {
          top: 20,
          right: 11,
          bottom: 0,
          left: 5,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          position: 'bottom',
          axisLine: { onZero: false },
          axisTick: { show: false },
          splitArea: { show: true },
          axisLabel: {
            interval: Math.round(data.x.length/6),
            showMinLabel: true,
            showMaxLabel: true,
            fontSize: 10,
            formatter: (value) => {
              const tmp = value.split('.')
              return tmp[0].substring(2,4) + '.' + tmp[1]
            }
          },
          data: data.x
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLabel: {
              fontSize: 10,
            },
            min: function (value) {
              let cap = value.max - value.min;
              const unit = getChartUnit(cap);

              if (value.min % unit === 0) {
                return value.min;
              } else {
                if (value.min >= 0) {
                  return value.min - (value.min % unit);
                }
              }
            }
          }
        ],
        tooltip: {
          trigger: 'axis',
          textStyle: {
            fontSize: 10
          }
        },
        series: [
          {
            name: title[0],
            data: data.y1,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[0] },
            lineStyle: { color: lineColor[0], width: 1 },
            areaStyle: {
              color: '#1d2a53',
              opacity: 0.6
            }
          },
          {
            name: title[1],
            data: data.y2,
            type: 'line',
            symbol: 'none',
            sampling: 'minmax',
            itemStyle: { color: lineColor[1] },
            lineStyle: { color: lineColor[1], width: 2 }
          }
        ]
      }
      setOptions(option);
    }
  }, [data, title]);

	return (
    <div className="graph" style={{ height: '200px' }}>
      { options &&
        <ECharts option={options} style={{ width: '100%', height: '100%' }} />
      }
    </div>
  );
}

export default RelativeRate;
